import styled from 'styled-components';
import { Autocomplete } from '@material-ui/lab';

export const CustomAutocomplete = styled(Autocomplete).attrs({
  clearText: 'Limpar',
  noOptionsText: 'Nenhum valor encontrado',
  openText: 'Abrir',
  closeText: 'Fechar',
})`` as typeof Autocomplete;
